import * as React from "react";
import { Upload, message, Button } from "antd";
import { CustomModal } from "../common/CustomModal";
import styled from "styled-components";
import { COURSE_INTRO_UPLOAD_PATH } from "../../constant/comman";

const Dragger = Upload.Dragger;

const StyledDragger = styled(Dragger)`
  & .ant-upload {
    margin-bottom: 15px;
  }

  & .ant-upload-drag {
    margin-bottom: 15px;
  }
  & .ant-upload-list-item-actions {
    display: none;
  }
`;

const props = {
  name: "file",
  action: COURSE_INTRO_UPLOAD_PATH,
  headers: {
    authorization: "authorization-text",
  },
};

var temp = [];
var isUploadClick = false;

export class AddCourseIntroMedia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disable: true,
      jsonFile: [],
      disableUpload: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.verifyDoc = this.verifyDoc.bind(this);
  }

  componentDidMount() {
    if (this.props.refx) {
      this.props.refx(this);
    }
  }

  verifyDoc() {
    isUploadClick = true;

    if (temp.length <= 0) {
      message.error("Please select a valid video");
      return;
    }

    const introData = {
      media_name: temp[0].response.file,
      type: "video",
      media_type: "intro",
      thumb_media_name: temp[0].response.thumb_media_name,
    };

    this.props.onUpload(temp[0].response.file, introData);
  }

  handleChange(info) {
    if (info.file.status !== "uploading") {
      if (info.fileList.length < 1) {
        this.setState({
          disable: true,
        });
      } else {
        this.setState({
          disable: false,
        });
      }
    }

    if (info.file.status === "done") {
      if (info.file.response.code === "ERROR_IN_UPLOAD") {
        message.error(info.file.response.msg);
      } else {
        message.success(`${info.file.name} file uploaded successfully.`);
        temp = info.fileList;
      }
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  }

  handleCancel = (e) => {
    this.hide();
  };

  show() {
    this.setState({
      visible: true,
    });
  }

  hide() {
    this.setState(
      {
        visible: false,
      },
      () =>
        isUploadClick ? this.props.onUpload(temp) : this.props.onUpload(null)
    );
  }

  render() {
    return (
      <CustomModal
        width="600px"
        title="Upload Intro Video"
        visible={this.state.visible}
        onClose={this.handleCancel.bind(this)}
        maskClosable={false}
      >
        <div className="premium-upload-container">
          <StyledDragger
            accept=".webm,.mpg,.mp2,.mpeg,.mpe,.mpv,.mp4,.m4p,.m4v,.mkv,.flv,.vob,.svi,.ogg,.ogv,.mov"
            className="premium-upload-dragger"
            {...props}
            onChange={this.handleChange}
            onRemove={(file) => console.log("Removed -- ", file)}
          >
            <div className="premium-upload-icon-wrapper">
              <svg viewBox="0 0 24 24">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" />
              </svg>
            </div>
            <p className="premium-upload-text">
              Click or drag video to this area
            </p>
            <p className="premium-upload-hint">
              Supports single video upload (.mp4, .mov, .webm, .mkv)
            </p>
          </StyledDragger>

          <div className="premium-upload-actions">
            <Button
              className="premium-cancel-btn"
              onClick={this.handleCancel.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="premium-upload-btn"
              disabled={this.state.disable}
              onClick={this.verifyDoc}
            >
              Upload
            </Button>
          </div>
        </div>
      </CustomModal>
    );
  }
}
